import React from "react";
import {Flex, Text, Box} from "@chakra-ui/react";
import {FiHome, FiChevronRight} from "react-icons/fi";

export default function Breadcrumb({currentPath, rootPath, onNavigate}) {
  // Build segments from currentPath relative to rootPath
  const relativePath = currentPath.startsWith(rootPath)
    ? currentPath.slice(rootPath.length)
    : currentPath;
  const segments = relativePath.split("/").filter(Boolean);

  return (
    <Flex
      align="center"
      gap={0}
      py={2}
      px={1}
      mb={3}
      minH="36px"
      flexWrap="wrap"
      rowGap={1}
    >
      {/* Home / root */}
      <Flex
        align="center"
        gap={1.5}
        px={2}
        py={1}
        borderRadius="6px"
        cursor="pointer"
        color={segments.length === 0 ? "blue.600" : "gray.500"}
        fontWeight={segments.length === 0 ? "600" : "500"}
        bg={segments.length === 0 ? "blue.50" : "transparent"}
        _hover={{bg: "gray.100", color: "gray.700"}}
        transition="all 0.15s ease"
        onClick={() => onNavigate(rootPath)}
        userSelect="none"
      >
        <Box as={FiHome} fontSize="14px" />
        <Text fontSize="13px">Files</Text>
      </Flex>

      {segments.map((segment, i) => {
        const isLast = i === segments.length - 1;
        // Build the path up to this segment
        const segmentPath = rootPath + segments.slice(0, i + 1).join("/") + "/";

        return (
          <Flex key={segmentPath} align="center" gap={0}>
            <Box
              as={FiChevronRight}
              fontSize="14px"
              color="gray.300"
              mx={0.5}
              flexShrink={0}
            />
            <Text
              fontSize="13px"
              px={2}
              py={1}
              borderRadius="6px"
              cursor={isLast ? "default" : "pointer"}
              color={isLast ? "gray.800" : "gray.500"}
              fontWeight={isLast ? "600" : "500"}
              bg={isLast ? "gray.50" : "transparent"}
              _hover={isLast ? {} : {bg: "gray.100", color: "gray.700"}}
              transition="all 0.15s ease"
              onClick={isLast ? undefined : () => onNavigate(segmentPath)}
              noOfLines={1}
              maxW="200px"
              userSelect="none"
            >
              {segment}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
}
